import { render, staticRenderFns } from "./sindex.vue?vue&type=template&id=60144cb7&scoped=true&"
import script from "./sindex.vue?vue&type=script&lang=js&"
export * from "./sindex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60144cb7",
  null
  
)

export default component.exports